export default "__VITE_ASSET__Dx5p$l$R__"